import { Typography, tk, horizontalGap, verticalGap, Skeleton } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';
import { useIntl } from 'react-intl';
import { useUserReviewsInitialData } from '@/scopes/products/user-reviews/hooks';
import { useCMSPageField } from '@/cms/fields';

const AmountLabel = styled(Typography)`
  color: ${tk('color_semantic_text_strong')};
`;

const Wrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;

  ${horizontalGap('spacing_xs')}

  &:hover {
    cursor: pointer;

    ${AmountLabel} {
      text-decoration: underline;
    }
  }
`;

const LabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const RatingScoreSkeleton = styled(Skeleton)`
  width: ${tk('spacing_2xl')};
  height: ${tk('spacing_2xl')};
`;

const LabelSkeleton = styled(Skeleton)`
  width: 100px;
  height: ${tk('typography_body_sm_bold_size')};
`;

const LabelWrapperSkeleton = styled(LabelWrapper)`
  ${verticalGap('spacing_xs')}
`;

interface RatingProps {
  onClick: () => void;
}

export function Rating({ onClick }: RatingProps) {
  const intl = useIntl();
  const ratingsCount = useCMSPageField('userReviews.ratingsCount');
  const ratingAverage = useCMSPageField('userReviews.ratingAverage');
  const mostRatedCategoryScore = useCMSPageField('userReviews.mostRatedCategoryScore');
  const shouldShowRatings = useCMSPageField('userReviews.shouldShowRatings');

  const { isLoading } = useUserReviewsInitialData();

  if (isLoading)
    return (
      <Wrapper>
        <RatingScoreSkeleton />
        <LabelWrapperSkeleton>
          <LabelSkeleton />
          <LabelSkeleton />
        </LabelWrapperSkeleton>
      </Wrapper>
    );

  if (!shouldShowRatings) return null;

  return (
    <Wrapper onClick={onClick}>
      <Typography $variant="heading-xl">{ratingAverage}</Typography>
      <LabelWrapper>
        <Typography $variant="body-md-bold">
          {mostRatedCategoryScore &&
            intl.formatMessage({ id: `reviews_score_bar_label_${mostRatedCategoryScore?.typeId ?? '0'}` })}
        </Typography>
        <AmountLabel $variant="body-sm">{ratingsCount} ervaringen</AmountLabel>
      </LabelWrapper>
    </Wrapper>
  );
}
